import React from 'react';
import { Button, Emoji } from '@fourthwall/components';
import * as S from './SuccessStage.styled';
export const SuccessStage = ({ onClaimFreeDomain, onOrderSamples, onClose }) => {
    return (React.createElement(S.Content, null,
        React.createElement(S.Text, null,
            "You\u2019ve unlocked powerful tools to grow your brand like never before. Let\u2019s build something amazing together. ",
            React.createElement(Emoji, { shortcode: "rocket" })),
        React.createElement(S.Text, null, "Start with Fourthwall Pro\u2019s top feature: a free custom domain just for you:"),
        React.createElement(S.ButtonsContainer, null,
            React.createElement(Button, { label: "Claim free domain", appearance: "primary", fullWidth: true, onClick: onClaimFreeDomain }),
            React.createElement(Button, { label: "Order samples", appearance: "secondary", fullWidth: true, onClick: onOrderSamples }),
            React.createElement(Button, { label: "Back to dashboard", appearance: "secondary", fullWidth: true, onClick: onClose }))));
};
